<template>
  <div class="wh-screen">
    <global-confirm-box ref="confirmBox" />
    <warehouse-offer-invoice-dialog v-model="waybillDialog" :edited-item="editedItem" @success="load" />
    <warehouse-doc-screen
      v-bind="docProps"
      :mobile="device.isMobile"
      @hint="setFiltersToLastEntry"
      @open-row="openRowDoc"
      @toast="$emit('toast', $event)"
    >
      <template #cell="{ row, column }">
        <span v-if="column.key === 'status' && row.status" class="wh-status" :class="`wh-status--${statusTone(row.status)}`">
          {{ row.statusLabel }}
        </span>
        <template v-else>{{ cellText(row[column.key]) }}</template>
      </template>
      <template #row-actions="{ row }">
        <warehouse-row-button icon="mdi-eye" :label="$t('overview')" tone="pri" action="view" @click="openRowDoc(row)" />
      </template>
    </warehouse-doc-screen>
  </div>
</template>

<script>
import WarehouseTabOffersInvoices from "@/components/warehouse/tabs/WarehouseTabOffersInvoices.vue";
import WarehouseDocScreen from "../../docs/WarehouseDocScreen.vue";
import WarehouseRowButton from "../../docs/WarehouseRowButton.vue";
import hasDocumentListScreen from "../../docs/hasDocumentListScreen";
import { OFFER_STATUS_TONE } from "../../docs/docStatus";

/**
 * Ponude i fakture dobavljača: lista dokumenata sa statusom i pregledom (ponude stižu od dobavljača, pa nema dugmeta za
 * dodavanje). Nasleđuje učitavanje, filtriranje, štampu, Excel i dijalog iz starog taba.
 */
export default {
  name: "WarehouseScreenOffers",
  extends: WarehouseTabOffersInvoices,
  mixins: [hasDocumentListScreen],
  components: { WarehouseDocScreen, WarehouseRowButton },
  computed: {
    docConfig() {
      return {
        icon: "mdi-file-document-outline",
        hintKey: "warehouse.last_invoice",
        emptyTitleKey: "warehouse.offers_invoices",
        emptyTextKey: "no_invoices_yet",
        open: "editItem",
        remove: null,
      };
    },
    docGrouped() {
      return false;
    },
    docAggregateAvailable() {
      return false;
    },
    docExpandable() {
      return false;
    },
    docActions() {
      return [];
    },
    docColumns() {
      return [
        { key: "id", label: "ID", mobile: "sub", muted: true, num: true, prefix: "#" },
        { key: "number", label: this.$t("warehouse.document_number_short"), main: true, mobile: "title" },
        { key: "document_date", label: this.$t("date"), mobile: "meta" },
        { key: "supplier", label: this.$t("supplier"), mobile: "meta" },
        { key: "status", label: this.$t("status"), mobile: "badge" },
      ];
    },
  },
  methods: {
    docRow(item) {
      const status = item.status || "";
      return {
        key: item.id,
        raw: item,
        group: { id: item.warehouse_id || 0, name: "" },
        id: item.id,
        number: item.number || "",
        document_date: item.document_date ? this.localeDate(item.document_date) : "",
        supplier: (item.supplier && item.supplier.name) || "",
        status,
        statusLabel: this.offerStatusLabel(status),
        sort: { id: Number(item.id) || 0, document_date: item.document_date || "", status },
      };
    },
    offerStatusLabel(status) {
      const key = `warehouse.offer_status_${status}`;
      return this.$te(key) ? this.$t(key) : status;
    },
    statusTone(status) {
      return OFFER_STATUS_TONE[status] || "neutral";
    },
  },
};
</script>
